import axios from "@/plugins/axios";

let url = "/api/console/shop/giftcards";

export default {
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
    get(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
    post(data){
        return axios.post(url, data).then(result => result.data);
    },
    put(data){
        return axios.put(`${url}/${data._id}`, data).then(result => result.data);
    },
    delete(data){
        return axios.delete(`${url}/${data._id}`).then(result => result.data);
    },

    thumb: {
        post(_giftcard, file){
            let data = new FormData(); data.append("thumb", file);
            let headers = { "Content-Type": "multipart/form-data" };
            return axios.post(`${url}/${_giftcard}/thumb`, data, { headers }).then(result => result.data);
        },
        delete(_giftcard){
            return axios.delete(`${url}/${_giftcard}/thumb`).then(result => result.data);
        }
    },

    images: {
        post(_giftcard, index, file){
            let data = new FormData(); data.append("image", file);
            let headers = { "Content-Type": "multipart/form-data"};
            return axios.post(`${url}/${_giftcard}/images/${index}`, data, { headers }).then(result => result.data);
        },
        delete(_giftcard, index){
            return axios.delete(`${url}/${_giftcard}/images/${index}`).then(result => result.data);
        }
    }
}
